import { InjectionToken } from '@angular/core';
import { HashMap, ProductType } from '@floori-web-components';
import {
    ProductFilterDefinitionDto,
    BreadcrumbItemDto,
    ProductFilter,
    ProductsFilterData,
    PagedResponse,
    ProductFilterResponseDto,
} from '@floori/models';
import { Observable } from 'rxjs';
import { FilterValues, ProductFilterValues } from '../filter-values';

export const FLOORI_DATA_ACCESS_PROVIDER = new InjectionToken('FLOORI_DATA_ACCESS_PROVIDER');

export interface DataAccessProvider {
    productsBaseData$: Observable<{
        filterDefinitions?: ProductFilterDefinitionDto[];
        breadcrumb?: BreadcrumbItemDto[];
    }>;
    selectFilterDefinitions$: Observable<ProductFilterDefinitionDto[] | undefined>;
    selectFilterValues$: Observable<ProductFilterValues>;
    filtersLoading$: Observable<boolean>;
    questionsData$: Observable<{
        questionsAnswered: boolean;
        questionsFilters: ProductFilter[] | undefined;
    }>;
    productErrors$: Observable<HashMap<boolean>>;
    hotpointsReady$: Observable<boolean>;

    getCatalogId(breadcrumb: BreadcrumbItemDto[] | undefined): string;

    setFiltersLoading(value: boolean): void;

    setHotpointsReady(value: boolean): void;

    setQuestionsAnswered(value: boolean): void;

    setQuestionsFilters(
        filterDefsMap: HashMap<ProductFilterDefinitionDto>,
        filters: FilterValues,
    ): void;

    patchFilters(
        filters: Partial<ProductsFilterData>,
        execute?: boolean,
        productType?: ProductType,
        updateMetadata?: boolean,
        metadata?: Record<string, unknown>,
    ): void;

    filterProductsCall(
        filters: ProductsFilterData,
        metadata?: Record<string, unknown>,
    ): Observable<[PagedResponse<ProductFilterResponseDto>, string]>;

    fetchProductBase(
        productId?: string,
        sku?: string,
        externalId?: string,
        metadata?: string,
    ): void;

    fetchFilterDefinitions(): void;

    fetchBreadcrumb(productId: string, metadata?: string): Observable<BreadcrumbItemDto[]>;

    setBreadcrumb(breadcrumb: BreadcrumbItemDto[]): void;

    clearBreadcrumb(): void;

    parseToFilterDefsCall(
        filterDefs: HashMap<ProductFilterDefinitionDto>,
        filters: FilterValues,
        currentValues?: HashMap<ProductFilter>,
    ): ProductFilter[];

    updateInitialMetadata(catalogId: string, metadata: Record<string, unknown>): void;
}
